import { h } from 'vue'
import type { IconSet, IconProps } from 'vuetify'
import * as PhosphorIcons from '@phosphor-icons/vue'

type PhosphorIconName = keyof typeof PhosphorIcons

export const phosphorVueIconSet: IconSet = {
  component: (props: IconProps) => {
    const { icon } = props

    if (typeof icon !== 'string') {
      console.warn(`[Phosphor] Unsupported icon type`, icon)
      return null
    }

    if (!Object.prototype.hasOwnProperty.call(PhosphorIcons, icon)) {
      console.warn(`[Phosphor] Icon "${icon}" not found!`)
      return null
    }

    const IconComponent = PhosphorIcons[icon as PhosphorIconName]

    return h(IconComponent)
  },
}
